import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { isObjectEmpty } from '@/utils/comparisonUtils';
import { CallToActionKind } from '@/types';

import ReturnButton from '@/components/account/ReturnButton';
import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import DesignationList from '@/components/primeurAlert/DesignationList';
import PrimeurUserNoData from '@/components/primeurAlert/PrimeurUserNoData';
import PrimeurSearchBar from '@/components/primeurAlert/PrimeurSearchBar';

import styles from './PrimeurSearch.module.scss';
import { URLS } from '@/constants/urls';

export const PrimeurSearch = ({ designations, alertList, onAlertMe, onReturn, isMobileOrTablet }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [designationsList, setDesignationsList] = useState(designations);
  let isDesignation = false;
  const totalProductsToBeAlertedOn = Object.values(designations).flat().length;

  Object.keys(designationsList).forEach((key) => {
    if (designationsList[key].length > 0) {
      isDesignation = true;
    }
  });

  const subscribeToAllAlerts = () => {
    let isAllChecked = false;
    if (alertList?.length >= totalProductsToBeAlertedOn) {
      isAllChecked = true;
    }
    const allPartnumbers = Object.values(designations).flat().map((product) => product.partnumber);
    onAlertMe(allPartnumbers, undefined, isAllChecked);
  };

  const label = alertList?.length >= totalProductsToBeAlertedOn ? t('alert.deleteAll') : t('alert.subscribeToAllAlerts');
  const buttonKind = alertList?.length >= totalProductsToBeAlertedOn ? CallToActionKind.SECONDARY : CallToActionKind.PRIMARY;

  return (
    <>
      {isMobileOrTablet &&
        <ReturnButton onClick={() => onReturn()} />
      }
      <h1 className={styles.title}>{t('alert.search')}</h1>
      {!isObjectEmpty(designationsList) ? (
        <>
          <CallToActionContainer
            kind={buttonKind}
            onClick={subscribeToAllAlerts}
            className={styles.button}
          >
            {label}
          </CallToActionContainer>
          <PrimeurSearchBar
            designations={designations}
            setDesignations={setDesignationsList}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
          {isDesignation ? (
            <DesignationList
              designations={designationsList}
              alertList={alertList}
              onAlertMe={onAlertMe}
            />
          ) : (
            <div className={styles['no-matching-item']} data-rbf="no-matching-item" data-test-id="no-matching-item">
              <div className={styles['no-matching-item-title']}>
                {t('category:noSearchResult.noMatchingItem.title', { searchTerm })}
              </div>
              <span className={styles['no-matching-item-subTitle']}>
                {t('category:noSearchResult.noMatchingItem.subTitle')}
              </span>
            </div>
          )}
        </>
      ) : (
        <PrimeurUserNoData
          img={URLS.PRIMEUR_SEARCH}
          alt="search"
          text={t('alert.noActive')}
        />
        // TODO : Ajouter les traductions
      )}
    </>
  );
};

PrimeurSearch.propTypes = {
  designations: PropTypes.object.isRequired,
  alertList: PropTypes.array,
  onAlertMe: PropTypes.func,
  onReturn: PropTypes.func,
  isMobileOrTablet: PropTypes.bool
};

export default PrimeurSearch;
